var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1666957561227,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5458,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M921.159262 782.437316 100.165816 782.437316c-20.860097 0-37.20025-17.045211-37.20025-38.804794L62.965565 281.137005c0-21.872147 16.340153-39.004339 37.20025-39.004339l820.992423 0c21.077038 0 38.223556 17.497513 38.223556 39.004339l0 462.496539C959.381795 765.030877 942.235276 782.437316 921.159262 782.437316zM100.165816 267.714298c-6.622838 0-11.617595 5.770424-11.617595 13.421684l0 462.496539c0 7.537673 4.994758 13.222139 11.617595 13.222139l820.992423 0c6.970762 0 12.640901-5.931083 12.640901-13.222139L933.79914 281.137005c0-7.275707-5.788843-13.421684-12.640901-13.421684L100.165816 267.715321z",
    "p-id": 5459
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M517.677814 532.029172 92.344686 288.98781 105.072569 266.714528 517.741259 502.520091 934.673044 266.686898 947.302689 289.01544Z",
    "p-id": 5460
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6b9b539f.svg";
export { ForwardRef as ReactComponent };